'use strict';

export function findHostInstance(_component) {}
//# sourceMappingURL=findHostInstance.web.js.map